<div class="flex flex-col justify-center text-left w-full " [formGroup]="discountCodeForm">

  <app-form-input [label]="label" [black]="black" placeholder="" class=" w-full m-auto" [formGroup]="discountCodeForm" name="code" [showValidationErrors]="false"></app-form-input>

  <p *ngIf="discountCodeForm.controls.code?.value" class="font-theme-source text-white bg-theme-green-110 rounded-lg text-md w-full mt-2 mb-2 m-auto font-medium border-white"
    [class.bg-theme-green-110]="!currentDiscount?.notFound && currentDiscount?.status == 'authorized'"
    [class.bg-theme-orange]="currentDiscount?.notFound || currentDiscount?.status != 'authorized'"
    [class.border-2]="currentDiscount"
    [class.p-2]="currentDiscount"
  >
    <span  *ngIf="discountCodeForm.valid && (currentDiscount?.notFound || !currentDiscount)">Code non trouvé</span>
    <span  *ngIf="!currentDiscount?.notFound && currentDiscount?.status == 'authorized' && currentDiscount?.deliveredByContactId">
      Réduction de {{currentDiscount?.amountInEuros | showPrice}} obtenu par {{currentDiscount?.deliveredByFirstname}}</span>
    <span  *ngIf="!currentDiscount?.notFound && currentDiscount?.status == 'authorized' && !currentDiscount?.deliveredByContactId">
      Réduction de {{currentDiscount?.amountInPercents}}%</span>
    <span  *ngIf="!currentDiscount?.notFound && currentDiscount?.status == 'waiting_payment'">
      Code non valide car ton parrain n'a pas validé le paiement de son billet.</span>

  </p>

</div>
